import { useEffect, useRef, useState } from 'react';

import { scrollToElementWithOffset } from '../utils/scroll';

const FEEDBACK_FADE_MS = 250;

export function useMealsSelection({ initialDraft, onSaveMeals }) {
    const [draft, setDraft] = useState({
        lunsjer: [],
        middager: [],
        allergier: ''
    });
    const [isSaving, setIsSaving] = useState(false);
    const [feedback, setFeedback] = useState(null);
    const [feedbackVisible, setFeedbackVisible] = useState(false);

    const feedbackRef = useRef(null);

    useEffect(() => {
        setDraft(initialDraft);
    }, [initialDraft]);

    useEffect(() => {
        if (!feedback) return;

        setFeedbackVisible(false);

        const showFrame = window.requestAnimationFrame(() => {
            setFeedbackVisible(true);
        });

        return () => {
            window.cancelAnimationFrame(showFrame);
        };
    }, [feedback]);

    useEffect(() => {
        if (!feedback || !feedbackRef.current) return;

        window.requestAnimationFrame(() => {
            scrollToElementWithOffset(feedbackRef.current, 190);
        });
    }, [feedback]);

    const clearFeedback = () => {
        setFeedbackVisible(false);

        window.setTimeout(() => {
            setFeedback(null);
        }, FEEDBACK_FADE_MS);
    };

    const toggleDato = (type, dato) => {
        if (feedback) {
            clearFeedback();
        }

        setDraft(prev => {
            const current = prev[type];
            const exists = current.includes(dato);

            return {
                ...prev,
                [type]: exists ? current.filter(value => value !== dato) : [...current, dato]
            };
        });
    };

    const setAllergier = value => {
        if (feedback) {
            clearFeedback();
        }

        setDraft(prev => ({ ...prev, allergier: value }));
    };

    const saveMeals = async () => {
        setIsSaving(true);

        const result = await onSaveMeals({
            lunsjer: draft.lunsjer,
            middager: draft.middager,
            allergier: draft.allergier
        });

        setIsSaving(false);
        setFeedback({
            type: result.success ? 'success' : 'danger',
            message: result.message
        });
    };

    return {
        draft,
        isSaving,
        feedback,
        feedbackVisible,
        feedbackRef,
        toggleDato,
        setAllergier,
        saveMeals
    };
}
